module.exports = __webpack_public_path__ + "static/img/location_1042785.1fea68f.png";